import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/international/student/page',
    add:'/api-ir/international/student/add',
    update:'/api-ir/international/student/edit',
    info:'/api-ir/international/student/info/',
    del:'/api-ir/international/student/delete/',
}
// 查询留学生列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增留学生
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改留学生
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询留学生信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除留学生
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
